export const SteviloDniMedDatumi = {
  methods: {
    PridobiSteviloDni (prenosniParam) {
      // format datuma Fri Jun 04 2021 14:21:00 GMT+0200 (Srednjeevropski poletni čas)
      let date1 = prenosniParam.prenesenDanasnjiDatum.getTime()
      let date2 = prenosniParam.prenesenZacetniDatum.getTime()
      // Dan v milisekundag
      let dan = 1000 * 60 * 60 * 24
      // // Izračun časovne razlike med dvema datumoma
      let razlikamedDatumoma = date2 - date1
      // // Izračun št. dni med dvema datumoma
      let steviloDniMedDatumoma = Math.round(razlikamedDatumoma / dan) + 1
      return steviloDniMedDatumoma
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SteviloDniMedDatumi.js